<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h5>Asistente para el registro de Médicos</h5>
    <div style="display: flex; justify-content: space-between; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
      <h4>Paso 2: Especialidad</h4>
<!--
      <h4 style="margin: 0;">
        <span class="btn btn-secondary">1</span>
        <span class="btn btn-success"><b>2</b></span>
        <span class="btn btn-secondary">3</span>
      </h4>
-->
    </div>
    <hr>
<!-- Modal -->
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMedico" class="form-label">IdMedico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedico" name="idMedico" v-model="datoMedico.idMedico" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Persona -->
<!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoMedico.idPersona" disabled>
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombreCompleto }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
<!-- Botón Lista de Valores  Persona -->
<!-- Botón Lista de Valores  Especialidad -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoMedico.idEspecialidad">
                      <option v-for="especialidad in especialidads" :value="especialidad.idEspecialidad" :key="especialidad.idEspecialidad">
                        {{ especialidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Especialidad -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoMedico.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="submit" class="btn btn-light" @click.prevent="verPersona" title="Anterior" style="display: flex; align-items: center; justify-content: center;">
            <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;">chevron_left</span>Anterior
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedico" title="Continuar" style="display: flex; align-items: center; justify-content: center;">
          Siguiente<span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
import { validarForm } from '@/modules/validacionesForms.js'

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      medicos : [],
      datoMedico : {},
      nombreBusqueda: '',
      titulo: '',
      modalWindow: true,
      p_idMedico: 0,
      personas: [],
      especialidads: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
//    alert('empresa: '+window.sessionStorage.getItem("idEmpresa")+'; suscripcion: '+window.sessionStorage.getItem("idSuscripcion"));
    this.p_idPersona = this.$route.params.p_idpersona
//    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
//    this.fetchPersonas()
    this.fetchEspecialidads()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
   getData() {
      api.get('/vwmedicos/'+this.p_idMedico)
        .then(response => {
          this.datoMedico = response.data;
        })
        .catch(error => {
         console.error('Error al obtener datos de la persona:', error);
        });
    },
    validarForm(){
      const requiredFields = [
        'idEspecialidad'
        ,'documento'
      ];
      const requiredFieldsText = [
        'Especialidad'
        ,'documento'
      ];
      return validarForm(this.datoMedico, requiredFields, requiredFieldsText);
    },
    async verPersona() {
      this.$router.push('/medico01/' + this.p_idPersona)
    },
    async guardarMedico(){
      if(this.validarForm() === 1){
        try {
          this.datoMedico.idPersona = this.p_idPersona;
          await api.post('/medicos?idEmpresa='+window.sessionStorage.getItem("idEmpresa")+
                                                          '&idSuscripcion='+window.sessionStorage.getItem("idSuscripcion"), this.datoMedico).then(response => {
            this.medicos = response.data;
            this.datoMedico.idMedico = this.medicos.idMedico;
          });          
//          $('#ventanaModal').modal('hide');
//          swal("Correcto!", "Medico creada exitosamente!", "success");
//          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
        this.$router.push('/medico03/'+this.medicos.idMedico)
      }
    },
/*    
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/vwpersonas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
*/    
    fetchEspecialidads() {
      fetch('http://localhost:8080/api/v1/vwespecialidads')
        .then(response => response.json())
        .then(data => {
          this.especialidads = data;
        })
        .catch(error => {
          console.error('Error fetching especialidads:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
